export const PUBLIC_NAV_PATHS = ["/login", "/request", "/contact", "/tutorial", "/ai-assistants"];

export function usesPublicNav(path, isLoggedIn) {
	return !isLoggedIn && PUBLIC_NAV_PATHS.includes(path);
}
